import { API, AUTH } from '@const'
import * as utils from '@utils'
import JwtDecode from 'jwt-decode'

export const ACTION_TYPE = {
    INIT: 'auth.init',
    LOGIN: 'auth.login',
    LOGOUT: 'auth.logout',
    COMPLETEDECIMAL: 'auth.completeDecimal',
    OTPBINDINGSUCESS: 'auth.otpBindingSucess',
}

const defaultState = {
    token: '',
    hasLogin: false,
    isSuperUser: false,
    isAdmin: false,
    userInfo: {},
    isCompleteDecimal: false,
    otpSettingShow: false,
    otpUrl: '',
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case ACTION_TYPE.INIT: {
            const token = localStorage.getItem('token')
            storeUserInfo(state, token)
            break
        }
        case ACTION_TYPE.LOGIN:
            handleLogin(state, action.payloadRes)
            break
        case ACTION_TYPE.LOGOUT:
            removeCache()
            state = defaultState
            break
        case ACTION_TYPE.COMPLETEDECIMAL:
            state.isCompleteDecimal = action.payload
            break
        case ACTION_TYPE.OTPBINDINGSUCESS:
            state.otpSettingShow = false
            state.otpUrl = ''
            break
        default:
    }

    return { ...state }
}

export function login(account, password, otp) {
    const params = {
        account,
        password
    }
    if (otp) {
        params.otp_code = otp
    }
    return new Promise((resolve, reject) =>
        utils.apiRequest(
            'post',
            API.WEBSITE_LOGIN,
            { ...params },
            (data) => {
                resolve(data)
            },
            (err) => {
                reject(err)
            }
        )
    )
}

function handleLogin(state, payloadRes) {
    if (payloadRes.jwt) {
        storeUserInfo(state, `Bearer ${payloadRes.jwt}`)
    } else if (payloadRes.otp_url) {
        /** 需綁定OTP */
        state.otpSettingShow = true
        state.otpUrl = payloadRes.otp_url
    }
}

function storeUserInfo(state, token = null) {
    if (token) {
        const userInfo = JwtDecode(token)

        if (utils.getCurrentUnix(0) >= userInfo.exp) {
            return
        }
        
        /** 由前端暫時移除權限表 */
        utils.tempRemoveAuthorization(userInfo.authorization_list)

        state.userInfo = {
            ...userInfo,
        }
        state.hasLogin = true
        state.isSuperUser = userInfo.role_id === AUTH.ROLE_ID_SUPER_USER
        state.isAdmin = userInfo.role_id === AUTH.ROLE_ID_SUPER_USER || userInfo.role_id === AUTH.ROLE_ID_ADMIN
        state.token = token
        localStorage.setItem('token', token)
    }
}

function removeCache() {
    localStorage.removeItem('token')
}
